
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practice-areas/modification",
      function () {
        return require("private-next-pages/practice-areas/modification/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practice-areas/modification"])
      });
    }
  